<!-- 由 suu 创建于 2025-03-14 星期五 -->
<template>
  <div class="project-one">
    <div class="activity-content">
      <!-- 教练信息 -->
      <!--  <div class="coach-info">
        <img class="avatar" :src="info && info.coach_image || defaultAvatar" alt="">
        <div class="coach-name">{{ (info && info.coach_name || '') | filterCoachName }}邀请您参加</div>
      </div> -->
      <!-- 目标 -->
      <div class="goal-container" ref="goal">
        <div class="goal-list" :class="{ 'check-wobble': isWobble }">
          <div
            class="goal-item"
            :class="{
              'goal-item-active': curGoalIndex === index,
              'goal-item-default': curGoalIndex === undefined
            }"
            v-for="(item, index) in goalData"
            @click="bindClickGoal(index)"
            :key="index"
          >
            <div class="goal-item-wrapper">
              <img class="goal-icon" :src="item.icon" alt="" />
              <div class="goal-text">{{ item.text }}</div>
              <div class="goal-btn">
                <img
                  class="goal-gou"
                  v-show="curGoalIndex == index"
                  src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/00da9a489928aec750c7e38e40199304_wh=60_45.webp"
                  alt=""
                />
                <span>{{ item.btn }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="activity-title">活动信息</div>
      <div class="coach-container">
        <div class="c-title">报名时间</div>
        <div class="activity-time"><span>3月19日 - 3月20日</span></div>
        <div class="c-title">邀请人</div>
        <div class="coach-info">
          <img
            class="avatar"
            :src="(info && info.coach_image) || defaultAvatar"
            alt=""
          />
          <div class="coach-name">{{
            ((info && info.coach_name) || '') | filterCoachName
          }}</div>
        </div>
        <div class="c-title">参与方式</div>
        <div class="step-list">
          <div class="step-item">
            <div class="step-btn">
              <span>第1步</span>
              <div class="dot-content">
                <div
                  class="dot-item"
                  v-for="(item, index) in 5"
                  :key="index"
                ></div>
              </div>
            </div>
            <div class="step-right">
              <div class="step-1"
                >从3个挑战目标中选择一个<br />并点击<span class="pink"
                  >【开始挑战】</span
                >按钮</div
              >
            </div>
          </div>
          <div class="step-item">
            <div class="step-btn">第2步</div>
            <div class="step-right">
              <div class="step-2"
                >教练将于3月20日前主动联系您确认<br />对赌目标</div
              >
              <div class="step2-tips"
                >因活动名额有限，每位教练最多接受<span class="pink"
                  >两位会员</span
                >的Project挑战</div
              >
            </div>
          </div>
        </div>
      </div>
      <img
        class="image-item"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/47b16ae071b9e996711596a03cc51937_wh=1059_4185.png"
        alt=""
      />
    </div>
    <div
      class="join-btn"
      :class="{ 'join-btn-disabled': isEnd }"
      @click="handleJoin"
    >
      <span>{{ isEnd == 1 ? '报名结束' : '开始挑战' }}</span>
      <img
        class="person-image"
        v-if="!isEnd"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/947e42414e9c05cbbd8b4f5c295f2a4a_wh=237_72.webp"
        alt=""
      />
    </div>
    <van-popup class="tip-popup" v-model="showToast">
      <ActivityToast
        @confirm="bindConfirmTip"
        @cancel="bindCancelTip"
        :title="toastOptions.title"
        :message="toastOptions.message"
        :confirmText="toastOptions.confirmText"
        :showCancel="toastOptions.showCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { goalData } from '../data.js'
import ActivityToast from './toast.vue'
export default {
  name: 'project-one',

  components: {
    ActivityToast
  },

  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      defaultAvatar:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58f1b7711997802b54f06bce56ad313f.png', //默认头像
      curGoalIndex: undefined,
      showToast: false,
      goalData: goalData,
      toastOptions: {
        title: '提示',
        message: '很抱歉！您主教练的挑战名额已满，期待您的下次参与~',
        confirmText: '好的',
        cancelText: '关闭',
        showCancel: true
      },
      isWobble: false
    }
  },
  filters: {
    filterCoachName(name) {
      return name ? name : '健萌健身'
    },
    filterTime(dateStr) {
      const date = new Date(dateStr.replace(/-/g, '/'))
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${month}月${day}日`
    }
  },
  computed: {
    /* 报名是否结束 */
    isEnd() {
      if (this.info) {
        let now = new Date(this.info.server_time.replace(/-/g, '/')).getTime()
        let endTime = new Date(
          this.info.e_enroll_tiem.replace(/-/g, '/')
        ).getTime()
        return now >= endTime
      } else {
        return true
      }
    },
    isApp() {
      return this.$betterwe.isApp()
    }
  },

  watch: {},

  created() {},

  mounted() {
    this.$http.get('member/index?a=shareLogPush', {
      from: `project活动-报名页曝光-${this.$route.query.tfrom || ''}`,
      from_id: 250319
    })
  },

  destroyed() {},

  methods: {
    bindClickGoal(index) {
      this.curGoalIndex = index
    },
    handleJoin() {
      this.$http.get('member/index?a=shareLogPush', {
        from: `project活动-我要挑战按钮点击-${this.$route.query.tfrom || ''}`,
        from_id: 250319
      })
      /* 报名期已经结束 */
      if (this.isEnd) {
        return
      }
      /* 未选择目标 */
      if (this.curGoalIndex === undefined) {
        this.handleShowTips()
        return
      }
      this.postUserData()
    },
    //显示没有选择挑战目标的提示
    handleShowTips() {
      this.$toast('请选择挑战目标')
      let el = this.$refs.goal
      if (el) {
        // 获取目标元素相对于视口顶部的距离
        const rect = el.getBoundingClientRect()
        // 获取视口高度
        const windowHeight = window.innerHeight
        // 计算要滚动到屏幕中间的目标位置
        const scrollTop = Math.round(
          window.scrollY + rect.top - windowHeight / 2 + el.offsetHeight / 2
        )

        // 记录开始滚动的时间
        const startTime = new Date().getTime()
        // 设定一个最大等待时间（防止异常情况导致事件未触发）
        const maxWaitTime = 1000
        let isScrolling = true
        const wobbleAnimate = () => {
          setTimeout(() => {
            this.isWobble = true
            el.addEventListener('animationend', () => {
              this.isWobble = false
            })
          }, 200)
        }
        // 监听 scroll 事件，通过判断滚动位置是否稳定来确定是否滚动结束
        const scrollListener = () => {
          if (Math.round(window.scrollY) === scrollTop) {
            const endTime = new Date().getTime()
            if (endTime - startTime > 100 && isScrolling) {
              // 简单判断滚动是否已经稳定（防止频繁触发）
              window.removeEventListener('scroll', scrollListener)
              isScrolling = false
              wobbleAnimate()
              // 在这里可以添加滚动结束后的相关逻辑
            }
          }
        }
        window.addEventListener('scroll', scrollListener)
        // 执行滚动操作
        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth' // 平滑滚动
        })
        //如果已经在这个位置则不需要在滚动直接抖动
        if (Math.round(window.scrollY) === scrollTop) {
          isScrolling = false
          wobbleAnimate()
        }
        // 设定一个定时器，防止滚动事件未触发导致一直等待
        setTimeout(() => {
          if (isScrolling) {
            window.removeEventListener('scroll', scrollListener)
            isScrolling = false
            wobbleAnimate()
          }
        }, maxWaitTime)
      }
    },
    async postUserData() {
      this.$toast.loading({
        forbidClick: true,
        message: '报名中...'
      })
      let res = await this.$http
        .get('member/activity.ActProject?a=enrollAct', {
          type: this.goalData[this.curGoalIndex].id
        })
        .catch(() => {})
      this.$toast.clear()
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('报名成功')
          this.$emit('success')
        } else {
          this.errCodeId = res.code
          //用户没有健萌卡特殊处理
          this.toastOptions.message =
            res.code === 10002
              ? '您当前没有可使用的正式会员卡，请办卡后参与挑战~'
              : res.msg
          let isJump = this.isJumpRoute(res.code)
          this.toastOptions.showCancel = Boolean(isJump)
          let textData = {
            0: '好的',
            1: '领取体验课',
            2: '我要购卡'
          }
          this.toastOptions.confirmText = textData[isJump]
          this.showToast = true
          this.bindBuiried()
        }
      }
    },
    bindBuiried() {
      if ([10002, 20001].includes(this.errCodeId)) {
        //非会员
        this.$http.get('member/index?a=shareLogPush', {
          from: `project活动-非健萌会员弹窗曝光-${
            this.$route.query.tfrom || ''
          }`,
          from_id: 250319
        })
      } else if (this.errCodeId === 20009) {
        //主教练名额已满
        this.$http.get('member/index?a=shareLogPush', {
          from: `project活动-主教练名额已满弹窗曝光-${
            this.$route.query.tfrom || ''
          }`,
          from_id: 250319
        })
      }
    },
    // 0不跳转  1 体验卡 2续卡
    isJumpRoute(codeId) {
      if ([10002, 20001, 20002].includes(codeId)) {
        //体验卡进线
        return 1
      } else if ([20009, 20011].includes(codeId)) {
        //不跳转
        return 0
      } else if ([20004, 20005, 20006, 20007, 20008, 20010].includes(codeId)) {
        //续卡小程序
        return 2
      } else {
        //不跳转
        return 0
      }
    },
    //根据code跳转路由
    jumpRouteByCodeId() {
      let jumpType = this.isJumpRoute(this.errCodeId)
      if (jumpType == 1) {
        //体验卡进线
        location.href =
          'https://work.weixin.qq.com/ca/cawcdec0299443f011?customer_channel=qywx_ca:107715923'
      } else if (jumpType == 2) {
        //续卡小程序
        if (this.isApp) {
          let env = this.$http.curEv()
          if (env == 'pro') {
            this.$betterwe.jumpRoute(
              '/miniProgram?userName=gh_83658789b5ba&path=%2Fpages%2Fwebview%2Fwebview%3Furl%3Donline-buy-card'
            )
          } else {
            this.$betterwe.jumpRoute(
              '/miniProgram?userName=gh_83658789b5ba&wxMiniProgramType=2&path=%2Fpages%2Fwebview%2Fwebview%3Furl%3Donline-buy-card'
            )
          }
        } else {
          this.$http._toVueH5Url('online-buy-card')
        }
      }
    },
    bindConfirmTip() {
      this.showToast = false
      this.jumpRouteByCodeId()
      this.bindClickBuiried()
      this.errCodeId = undefined
    },
    bindClickBuiried() {
      let jumpType = this.isJumpRoute(this.errCodeId)
      if (jumpType == 2) {
        this.$http.get('member/index?a=shareLogPush', {
          from: `project活动-我要购卡按钮点击-${this.$route.query.tfrom || ''}`,
          from_id: 250319
        })
      } else if (jumpType == 1) {
        this.$http.get('member/index?a=shareLogPush', {
          from: `project活动-领取体验课按钮点击-${
            this.$route.query.tfrom || ''
          }`,
          from_id: 250319
        })
      }
    },
    bindCancelTip() {
      this.showToast = false
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.tip-popup {
  border-radius: 10px;
}

.project-one {
  width: 100%;
  min-height: 100vh;
  background: #ff3b86;
  background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/560063c605470445e5bc61cc45b909ce_wh=1125_1158.webp');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center top;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .activity-content {
    width: 100%;
    padding-top: 400px;
    padding-bottom: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: stretch;
    position: relative;
    overflow: hidden;

    .goal-container {
      width: 343px;
      min-height: 164px;
      margin-bottom: 27px;

      .goal-list {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .goal-item {
          position: relative;
          box-sizing: border-box;
          margin-right: 10px;
          width: 96px;
          height: 160px;
          padding: 2px;
          background: #ffffff;
          border-radius: 14px;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;

          .goal-item-wrapper {
            padding: 4px 4px 7px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            border-radius: 14px;
            background: #ffffff;
            border: 3px solid #ffffff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          .goal-icon {
            width: 64px;
            height: 64px;
            object-fit: contain;
            margin-bottom: 5px;
          }

          .goal-text {
            font-family: MiSans, MiSans;
            font-weight: bold;
            font-size: 15px;
            color: #000000;
            line-height: 24px;
            margin-bottom: 16px;
          }

          .goal-btn {
            width: 100%;
            box-sizing: border-box;
            height: 30px;
            background: #ffffff;
            border-radius: 18px;
            border: 2px solid #ea3981;
            font-family: MiSans, MiSans;
            font-weight: bold;
            font-size: 14px;
            color: #ea3981;
            display: flex;
            align-items: center;
            justify-content: center;

            .goal-gou {
              width: 20px;
              height: 15px;
              margin-right: 3px;
            }
          }
        }

        .goal-item-default {
          width: 107.5px;
        }

        .goal-item:last-child {
          margin-right: 0;
        }

        .goal-item-active {
          width: 135px;
          height: 164px;
          background: #ffffff;
          box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.26);
          border-radius: 14px;

          .goal-item-wrapper {
            box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.26);
            border-radius: 14px;
            border: 3px solid #11cc66;
          }

          .goal-btn {
            width: 100%;
            box-sizing: border-box;
            height: 30px;
            background: #11cc66;
            border: 2px solid #11cc66;
            color: #fff;
          }

          .goal-btn {
            width: 100px;
          }
        }
      }
    }

    .activity-title {
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 24px;
      color: #ffffff;
      line-height: 23px;
      margin-bottom: 12px;
    }

    .coach-container {
      padding: 12px 10px 22px;
      background: #ffffff;
      border-radius: 10px;
      width: 343px;
      box-sizing: border-box;
      margin-bottom: 26px;

      .c-title {
        padding: 0px 8px;
        line-height: 25px;
        height: 25px;
        background: rgba(14, 9, 41, 0.05);
        border-radius: 4px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 15px;
        color: rgba(0, 0, 0, 0.5);
      }

      .activity-time {
        height: 23px;
        padding: 0px 8px;
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 18px;
        color: #000000;
        line-height: 23px;
        margin-top: 14px;
        margin-bottom: 16px;
      }

      .coach-info {
        padding: 0px 5px;
        margin-top: 15px;
        margin-bottom: 14px;
        display: flex;
        align-items: center;

        .avatar {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 11px;
        }

        .coach-name {
          white-space: nowrap;
          font-family: MiSans, MiSans;
          font-weight: bold;
          font-size: 18px;
          color: #000000;
        }
      }

      .step-list {
        margin-top: 12px;

        .step-item {
          margin-bottom: 17px;
          display: flex;
          align-items: flex-start;

          .step-btn {
            position: relative;
            width: 48px;
            height: 22px;
            border-radius: 3px;
            background: #ea3981;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: MiSans, MiSans;
            font-weight: bold;
            font-size: 13px;
            color: #ffffff;
            margin-right: 17px;

            .dot-content {
              position: absolute;
              width: 2px;
              left: 50%;
              transform: translate(-50%, 0%);
              top: 31px;
              height: 20px;

              .dot-item {
                width: 2px;
                height: 2px;
                background-color: #000;
                margin-bottom: 3px;
              }
            }
          }

          .step-right {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;

            .step-1 {
              font-family: MiSans, MiSans;
              font-weight: bold;
              font-size: 15px;
              color: #000000;
              line-height: 22px;

              .pink {
                color: rgba(234, 57, 129, 1);
              }
            }

            .step-2 {
              font-family: MiSans, MiSans;
              font-weight: bold;
              font-size: 15px;
              color: #ea3981;
              line-height: 23px;
            }

            .step2-tips {
              font-family: MiSans, MiSans;
              font-weight: 400;
              font-size: 12px;
              color: rgba(0, 0, 0, 0.7);
              line-height: 16px;

              .pink {
                color: rgba(234, 57, 129, 1);
              }
            }
          }
        }

        .step-item:last-child {
          margin-bottom: 0;
        }
      }
    }

    .image-item {
      width: 353px;
      margin: 0 auto;
    }
  }

  img {
    width: 100%;
    box-sizing: border-box;
  }

  .join-btn {
    position: fixed;
    left: 50%;
    bottom: 30px;
    transform: translate(-50%, 0%);
    width: 343px;
    height: 50px;
    box-sizing: border-box;
    border: 2px solid #fff;
    border-radius: 2px;
    background: rgba(17, 204, 102, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    border-radius: 25px;
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.26);

    .person-image {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(0%, -50%);
      width: 79px;
    }
  }
  .join-btn-disabled {
    background: rgb(195, 195, 195);
    border: 2px solid rgb(195, 195, 195);
  }
}

.check-wobble {
  animation: wobble 0.3s linear;
}

@keyframes wobble {
  0% {
    transform: translate(0px, 0px);
  }

  20% {
    transform: translate(-1px, 4px);
  }

  40% {
    transform: translate(3px, 0px);
  }

  60% {
    transform: translate(4px, 4px);
  }

  80% {
    transform: translate(-2px, -1px);
  }

  100% {
    transform: translate(2px, 0px);
  }
}
</style>
